let step = 1;
const total = 16;
let data = {};

function preloadImages() {
    const images = [
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/talkingpose1.png?v=1761701734',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/mon.png?v=1758291291',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/run_6fbe14c7-48c5-4255-a0d1-3f99c9506cd3.png?v=1761840574',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/weirdthink.png?v=1761840597',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/DUMBBELLrow_25887639-eeeb-421a-bb4b-56adeeec7634.png?v=1761840663',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/frontlatspread_1fd54eee-138a-4746-be6f-3e898fdffc8b.png?v=1761840742',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/lovely.png?v=1761840840',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/turn1_7e3ecbe7-f17a-443b-82c7-1c4f2bef2d6f.png?v=1761840911',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/a1_1c799979-0d63-41a6-be04-80c6fc912023.png?v=1762409210',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/a2_94588b2d-47dd-401c-985d-582f77687cec.png?v=1762409210',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/a3_c5109a5c-7a0a-49c5-9071-c628c124d9ec.png?v=1762409211',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/a4_f3a60b19-d3ab-472d-8b57-63e2f055426e.png?v=1762409210',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/cutie.png?v=1761702041',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/beginnerbundle_03a59bd2-2b72-4616-ac5e-5769beb3bdb2.png?v=1761665014',
        'https://bodybuildingsimplified.com/cdn/shop/files/NP_TP.png',
        'https://bodybuildingsimplified.com/cdn/shop/files/NUTRITION_TP_NEW.png',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/advancedbundle.png?v=1761403782',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/arnold_split_image.webp?v=1761403782',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/fullbodyimage.webp?v=1761403783',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/ul_image.webp?v=1761403782',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/pplimage.webp?v=1761403782',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/beginnertrainingplan.png?v=1761311815',
        'https://bodybuildingsimplified.com/cdn/shop/files/CUTTINGimg.png',
        'https://bodybuildingsimplified.com/cdn/shop/files/BULKINGimg.png',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/beginnernutritionguide.png?v=1761311814',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/MAINTENANCEimg_b52028a9-573d-42d9-8ed1-a56527be7375.png?v=1761848154',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/beginnercardioguide.png?v=1761311815',
        'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/ruckingIMG.png?v=1761406523'
    ];
    images.forEach(src => {
        const img = new Image();
        img.src = src;
    });
}

const imageMap = {
    bundles: {
        'Beginner Bundle': 'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/beginnerbundle_03a59bd2-2b72-4616-ac5e-5769beb3bdb2.png?v=1761665014',
        'Beginner Bodybuilding Bundle': 'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/beginnerbundle_03a59bd2-2b72-4616-ac5e-5769beb3bdb2.png?v=1761665014',
        '1+1 Bundle (Training + Nutrition)': 'https://bodybuildingsimplified.com/cdn/shop/files/NP_TP.png',
        '1+1 Bundle (Training + Full Nutrition)': 'https://bodybuildingsimplified.com/cdn/shop/files/NP_TP.png',
        '1 Training Plan + Full Nutrition Plan Bundle': 'https://bodybuildingsimplified.com/cdn/shop/files/NUTRITION_TP_NEW.png',
        'Advanced Bundle': 'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/advancedbundle.png?v=1761403782'
    },
    training: {
        'Arnold Split': 'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/arnold_split_image.webp?v=1761403782',
        'Full Body Plan': 'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/fullbodyimage.webp?v=1761403783',
        'Upper Lower Split': 'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/ul_image.webp?v=1761403782',
        'PPL (Push Pull Legs)': 'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/pplimage.webp?v=1761403782',
        'Beginner Training Plan': 'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/beginnertrainingplan.png?v=1761311815'
    },
    nutrition: {
        'Cutting Guide': 'https://bodybuildingsimplified.com/cdn/shop/files/CUTTINGimg.png',
        'Bulking Guide': 'https://bodybuildingsimplified.com/cdn/shop/files/BULKINGimg.png',
        'Beginner Nutrition Plan': 'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/beginnernutritionguide.png?v=1761311814',
        'Maintenance Plan': 'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/MAINTENANCEimg_b52028a9-573d-42d9-8ed1-a56527be7375.png?v=1761848154'
    },
    other: {
        'Beginner Cardio Plan': 'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/beginnercardioguide.png?v=1761311815',
        'Rucking Guide': 'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/ruckingIMG.png?v=1761406523'
    }
};

const productUrls = {
    // Bundles
    'Beginner Bodybuilding Bundle': 'https://bodybuildingsimplified.com/products/beginner-bundle',
    'Advanced Bundle': 'https://bodybuildingsimplified.com/products/advanced-bundle',
    '1 Training Plan + Full Nutrition Plan Bundle': 'https://bodybuildingsimplified.com/products/full-nutrition-plan-bundle-1-training-plan',
    '1+1 Bundle (Training + Full Nutrition)': 'https://bodybuildingsimplified.com/products/1-training-plan-1-nutrition-plan',
    // Training Plans
    'Arnold Split': 'https://bodybuildingsimplified.com/products/arnold-split-training-plan',
    'Full Body Plan': 'https://bodybuildingsimplified.com/products/full-body-training-plan',
    'Upper Lower Split': 'https://bodybuildingsimplified.com/products/upper-lower-training-plan',
    'PPL (Push Pull Legs)': 'https://bodybuildingsimplified.com/products/push-pull-legs-training-plan',
    // Nutrition Plans
    'Cutting Guide': 'https://bodybuildingsimplified.com/products/cutting-plan-guide',
    'Bulking Guide': 'https://bodybuildingsimplified.com/products/bulking-plan-guide',
    // Other
    'Rucking Guide': 'https://bodybuildingsimplified.com/products/rucking-plan-guide'
};

// Individual product variant IDs
const variantIds = {
    // Bundles - Simple ones only
    'Beginner Bodybuilding Bundle': '52037010882826',
    
    // Training Plans
    'Arnold Split': '50662218727690',
    'Full Body Plan': '44998891569418',
    'Upper Lower Split': '44998894682378',
    'PPL (Push Pull Legs)': '44998887833866',
    
    // Nutrition Plans
    'Cutting Guide': '45014492610826',
    'Bulking Guide': '45014494937354',
    
    // Other
    'Rucking Guide': '52132641472778'
};

// 1+1 Bundle Variants (Training + Nutrition)
const oneOneVariants = {
    'PPL (Push Pull Legs) + Bulking Guide': '45222753698058',
    'PPL (Push Pull Legs) + Cutting Guide': '45222753730826',
    'Upper Lower Split + Bulking Guide': '45222753763594',
    'Upper Lower Split + Cutting Guide': '45222753796362',
    'Full Body Plan + Bulking Guide': '45222753829130',
    'Full Body Plan + Cutting Guide': '45222753861898',
    'Arnold Split + Bulking Guide': '50700679708938',
    'Arnold Split + Cutting Guide': '50700679741706'
};

// Full Nutrition Bundle Variants (Training + All 3 Nutrition Guides)
const fullNutritionVariants = {
    'PPL (Push Pull Legs)': '45222808387850',
    'Upper Lower Split': '45222808420618',
    'Full Body Plan': '45222808453386',
    'Arnold Split': '50700690293002'
};

// Advanced Bundle Variants (Training + Nutrition + Rucking)
const advancedVariants = {
    'PPL (Push Pull Legs) + Cutting Guide': '52146214273290',
    'PPL (Push Pull Legs) + Bulking Guide': '52146214306058',
    'Upper Lower Split + Cutting Guide': '52146214338826',
    'Upper Lower Split + Bulking Guide': '52146214371594',
    'Full Body Plan + Cutting Guide': '52146214404362',
    'Full Body Plan + Bulking Guide': '52146214437130',
    'Arnold Split + Cutting Guide': '52146214469898',
    'Arnold Split + Bulking Guide': '52146214502666'
};

function getImageUrl(itemName) {
    if (imageMap.bundles[itemName]) return imageMap.bundles[itemName];
    if (imageMap.training[itemName]) return imageMap.training[itemName];
    if (imageMap.nutrition[itemName]) return imageMap.nutrition[itemName];
    if (imageMap.other[itemName]) return imageMap.other[itemName];
    return 'https://via.placeholder.com/300/FF6B6B/FFFFFF?text=' + encodeURIComponent(itemName);
}

const leftImages = [
    'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/talkingpose1.png?v=1761701734',
    'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/mon.png?v=1758291291',
    'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/run_6fbe14c7-48c5-4255-a0d1-3f99c9506cd3.png?v=1761840574',
    'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/weirdthink.png?v=1761840597'
];

const rightImages = [
    'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/DUMBBELLrow_25887639-eeeb-421a-bb4b-56adeeec7634.png?v=1761840663',
    'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/frontlatspread_1fd54eee-138a-4746-be6f-3e898fdffc8b.png?v=1761840742',
    'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/lovely.png?v=1761840840',
    'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/turn1_7e3ecbe7-f17a-443b-82c7-1c4f2bef2d6f.png?v=1761840911'
];

document.addEventListener('DOMContentLoaded', init);

function init() {
    preloadImages();
    updateProgress();
    setupRadios();
    setupInputs();
    setupSliders();
    updateSideImages();
    document.getElementById('winny-quiz-successCount').textContent = 200 + Math.floor(Math.random() * 100);
    data.heightUnit = 'feet';
    data.heightCm = 170;
    
    // Auto-open cart if coming back from add to cart
    if (window.location.search.includes('cart_open=true')) {
        setTimeout(() => {
            const cartIcon = document.querySelector('a[href="/cart"]') || 
                           document.querySelector('.cart-link') ||
                           document.querySelector('[data-cart-drawer-toggle]') ||
                           document.querySelector('.header__icon--cart');
            if (cartIcon) {
                cartIcon.click();
            }
        }, 500);
    }
}

function updateSideImages() {
    const imageIndex = Math.floor((step - 1) / 4) % 4;
    const leftImg = document.getElementById('winny-quiz-leftImage');
    const rightImg = document.getElementById('winny-quiz-rightImage');
    if (leftImg) leftImg.style.backgroundImage = `url('${leftImages[imageIndex]}')`;
    if (rightImg) rightImg.style.backgroundImage = `url('${rightImages[imageIndex]}')`;
}

function setupRadios() {
    document.querySelectorAll('.winny-quiz-radio-option').forEach(opt => {
        opt.onclick = function() {
            const inp = this.querySelector('input');
            const name = inp.name;
            document.querySelectorAll(`input[name="${name}"]`).forEach(r => {
                r.closest('.winny-quiz-radio-option').classList.remove('winny-quiz-selected');
            });
            this.classList.add('winny-quiz-selected');
            inp.checked = true;
            data[name] = inp.value;
            enableNext();
            if (window.innerWidth <= 768) {
                const btn = document.querySelector('.winny-quiz-step.winny-quiz-active .winny-quiz-btn-next');
                if (btn && !btn.disabled) {
                    setTimeout(() => goNext(), 300);
                }
            }
        };
    });
}

function setupInputs() {
    ['winny-quiz-userName', 'winny-quiz-currentWeight', 'winny-quiz-idealWeight'].forEach(id => {
        const el = document.getElementById(id);
        if (el) {
            el.oninput = function() {
                data[id.replace('winny-quiz-', '')] = this.value.trim();
                enableNext();
            };
        }
    });
}

function setupSliders() {
    const gd = document.getElementById('winny-quiz-gymDays');
    gd.oninput = function() {
        document.getElementById('winny-quiz-gymDaysValue').textContent = this.value;
        data.gymDays = parseInt(this.value);
    };
    const st = document.getElementById('winny-quiz-sessionTime');
    st.oninput = function() {
        document.getElementById('winny-quiz-sessionTimeValue').textContent = this.value;
        data.sessionTime = parseInt(this.value);
    };
    const cf = document.getElementById('winny-quiz-confusion');
    cf.oninput = function() {
        document.getElementById('winny-quiz-confusionValue').textContent = this.value;
        data.confusion = parseInt(this.value);
    };
    const ht = document.getElementById('winny-quiz-height');
    if (ht) {
        ht.oninput = function() {
            const heightCm = parseInt(this.value);
            updateHeight(heightCm);
        };
    }
}

function updateHeight(heightCm) {
    data.heightCm = heightCm;
    const unit = data.heightUnit || 'cm';
    const valueDisplay = document.getElementById('winny-quiz-heightValue');
    if (unit === 'feet') {
        const totalInches = heightCm / 2.54;
        const feet = Math.floor(totalInches / 12);
        const inches = Math.round(totalInches % 12);
        if (heightCm >= 190) {
            valueDisplay.textContent = `6'3"+`;
        } else if (heightCm <= 150) {
            valueDisplay.textContent = `<4'11"`;
        } else {
            valueDisplay.textContent = `${feet}'${inches}"`;
        }
    } else {
        if (heightCm >= 190) {
            valueDisplay.textContent = '190+';
        } else if (heightCm <= 150) {
            valueDisplay.textContent = '<150';
        } else {
            valueDisplay.textContent = heightCm;
        }
    }
    const img = document.getElementById('winny-quiz-heightImage');
    if (img) {
        const scale = 0.75 + ((heightCm - 150) / 40) * 0.5;
        img.style.transform = `scale(${scale})`;
    }
}

function selectHeightUnit(unit, btn) {
    data.heightUnit = unit;
    btn.parentElement.querySelectorAll('.winny-quiz-unit-btn').forEach(b => b.classList.remove('winny-quiz-active'));
    btn.classList.add('winny-quiz-active');
    const unitDisplay = document.getElementById('winny-quiz-heightUnit');
    unitDisplay.textContent = unit === 'feet' ? '' : 'cm';
    updateHeight(data.heightCm || 170);
}

function enableNext() {
    const curr = document.querySelector('.winny-quiz-step.winny-quiz-active');
    const btn = curr.querySelector('.winny-quiz-btn-next');
    if (!btn) return;
    if (step === 7) btn.disabled = !data.userName;
    else btn.disabled = false;
}

function selectUnit(type, unit, btn) {
    data[type + 'Unit'] = unit;
    btn.parentElement.querySelectorAll('.winny-quiz-unit-btn').forEach(b => b.classList.remove('winny-quiz-active'));
    btn.classList.add('winny-quiz-active');
}

function updateProgress() {
    const pct = Math.round((step / total) * 100);
    document.getElementById('winny-quiz-progressFill').style.width = pct + '%';
    document.getElementById('winny-quiz-progressPercent').textContent = pct;
}

function showStep(n) {
    document.querySelectorAll('.winny-quiz-step').forEach(s => s.classList.remove('winny-quiz-active'));
    document.querySelector(`[data-step="${n}"]`).classList.add('winny-quiz-active');
    updateSideImages();
}

function goNext() {
    const needsCardio = (data.cardio === 'yes-notenjoy' || data.cardio === 'no');
    const weightRequired = (data.goal === 'notsure' && needsCardio);
    
    if (step === 8 || step === 9) {
        const optionalText8 = document.getElementById('winny-quiz-weightOptional');
        const optionalText9 = document.getElementById('winny-quiz-idealOptional');
        if (weightRequired) {
            if (optionalText8) optionalText8.style.display = 'none';
            if (optionalText9) optionalText9.style.display = 'none';
        } else {
            if (optionalText8) optionalText8.style.display = 'block';
            if (optionalText9) optionalText9.style.display = 'block';
        }
    }
    
    if (step === 8) {
        let errorDiv8 = document.getElementById('winny-quiz-weightError');
        
        if (!errorDiv8) {
            errorDiv8 = document.createElement('div');
            errorDiv8.id = 'winny-quiz-weightError';
            errorDiv8.style.cssText = 'display: none; color: red; font-weight: bold; font-size: 1.1rem; margin-bottom: 15px; padding: 12px; background: #ffe0e0; border-radius: 8px; border: 2px solid red;';
            const currentStep = document.querySelector('[data-step="8"]');
            const question = currentStep.querySelector('.winny-quiz-question');
            question.insertAdjacentElement('afterend', errorDiv8);
        }
        
        errorDiv8.style.display = 'none';
        
        if (weightRequired && (!data.currentWeight || data.currentWeight.trim() === '')) {
            errorDiv8.textContent = 'Please enter your current weight to continue.';
            errorDiv8.style.display = 'block';
            return;
        }
        
        if (data.currentWeight && data.currentWeight.trim() !== '') {
            const currentWeight = parseFloat(data.currentWeight);
            
            if (currentWeight > 500 || currentWeight < 30) {
                errorDiv8.textContent = "C'mon, put some serious number in there!";
                errorDiv8.style.display = 'block';
                return;
            }
        }
        
        if (!weightRequired && (!data.currentWeight || data.currentWeight.trim() === '')) {
            step = 10;
            showStep(10);
            updateProgress();
            return;
        }
    }
    
    if (step === 9) {
        let errorDiv9 = document.getElementById('winny-quiz-idealWeightError');
        
        if (!errorDiv9) {
            errorDiv9 = document.createElement('div');
            errorDiv9.id = 'winny-quiz-idealWeightError';
            errorDiv9.style.cssText = 'display: none; color: red; font-weight: bold; font-size: 1.1rem; margin-bottom: 15px; padding: 12px; background: #ffe0e0; border-radius: 8px; border: 2px solid red;';
            const currentStep = document.querySelector('[data-step="9"]');
            const question = currentStep.querySelector('.winny-quiz-question');
            question.insertAdjacentElement('afterend', errorDiv9);
        }
        
        errorDiv9.style.display = 'none';
        
        if (weightRequired && (!data.idealWeight || data.idealWeight.trim() === '')) {
            errorDiv9.textContent = 'Please enter your ideal weight to continue.';
            errorDiv9.style.display = 'block';
            return;
        }
        
        if (data.currentWeight && data.idealWeight) {
            const currentWeight = parseFloat(data.currentWeight);
            const idealWeight = parseFloat(data.idealWeight);
            
            if (idealWeight > 500 || idealWeight < 30) {
                errorDiv9.textContent = "C'mon, put some serious number in there!";
                errorDiv9.style.display = 'block';
                return;
            }
            
            const difference = Math.abs(currentWeight - idealWeight);
            if (difference > 200) {
                errorDiv9.textContent = "C'mon, put some serious number in there!";
                errorDiv9.style.display = 'block';
                return;
            }
            
            if (currentWeight === idealWeight) {
                data.goal = 'bulking';
            }
        }
        
        step = 10;
        showStep(10);
        updateProgress();
        return;
    }
    
    if (step === 12) {
        const days = data.gymDays || 4;
        let txt = '';
        if (days === 2) txt = "That's alright, 2 days is plenty to get you started! 💪";
        else if (days === 3) txt = "3 days per week is a solid commitment! 💪";
        else if (days === 4) txt = "4 days per week? You're serious about this! 🔥";
        else if (days === 5) txt = "Whoa! 5 days per week, you're really committed! 🔥";
        else txt = "Whoa! 6 days per week, you're SERIOUSLY committed! 🔥💪";
        step = 13;
        showStep(13);
        updateProgress();
        setTimeout(() => {
            document.getElementById('winny-quiz-commitmentText').textContent = txt;
        }, 50);
        return;
    }
    
    if (step === 15) {
        step = 16;
        showStep(16);
        updateProgress();
        setTimeout(() => {
            finishQuiz();
        }, 2500);
        return;
    }
    step++;
    showStep(step);
    updateProgress();
}

function goBack() {
    step--;
    showStep(step);
    updateProgress();
}

function finishQuiz() {
    calculateResults();
    const quizWrapper = document.getElementById('winny-quiz-quizWrapper');
    const resultsWrapper = document.getElementById('winny-quiz-resultsWrapper');
    quizWrapper.classList.add('winny-quiz-fade-out');
    setTimeout(() => {
        quizWrapper.style.display = 'none';
        resultsWrapper.classList.add('winny-quiz-active');
        setTimeout(() => {
            resultsWrapper.classList.add('winny-quiz-fade-in');
        }, 50);
    }, 800);
}

function calculateResults() {
    if (data.experience === 'beginner') {
        data.training = 'Beginner Training Plan';
        data.nutrition = 'Beginner Nutrition Plan';
        data.cardio = 'Beginner Cardio Plan';
        data.bundle = 'Beginner Bundle';
        data.price = '$59.99';
        data.oldPrice = '$89.97';
        data.savings = 'Save $29.98!';
        data.items = [
            { name: 'Beginner Training Plan', price: 29.99, bundlePrice: 19.99, image: getImageUrl('Beginner Training Plan'), unavailable: true, bonuses: 0 },
            { name: 'Beginner Nutrition Plan', price: 29.99, bundlePrice: 19.99, image: getImageUrl('Beginner Nutrition Plan'), unavailable: true, bonuses: 0 },
            { name: 'Beginner Cardio Plan', price: 29.99, bundlePrice: 19.99, image: getImageUrl('Beginner Cardio Plan'), unavailable: true, bonuses: 0 }
        ];
        data.isBeginner = true;
        displayResults();
        return;
    }
    
    let training = '';
    const gymDays = data.gymDays || 4;
    if (data.shoulder === 'yes' && gymDays > 2) {
        training = 'Arnold Split';
    } else if (gymDays === 2 || gymDays === 3) {
        training = 'Full Body Plan';
    } else if (gymDays === 4) {
        training = 'Upper Lower Split';
    } else if (gymDays === 5) {
        training = 'Arnold Split';
    } else if (gymDays === 6) {
        training = 'PPL (Push Pull Legs)';
    } else {
        training = 'Upper Lower Split';
    }
    
    let nutrition = '';
    const needsCardio = (data.cardio === 'yes-notenjoy' || data.cardio === 'no');
    
    if (data.goal === 'cutting') {
        nutrition = 'Cutting Guide';
    } else if (data.goal === 'bulking') {
        nutrition = 'Bulking Guide';
    } else if (data.goal === 'notsure' && needsCardio) {
        const currentWeight = parseFloat(data.currentWeight) || 0;
        const idealWeight = parseFloat(data.idealWeight) || 0;
        if (currentWeight > idealWeight) {
            nutrition = 'Cutting Guide';
        } else {
            nutrition = 'Bulking Guide';
        }
    } else {
        nutrition = 'Cutting Guide';
    }
    
    let bundle = '';
    let price = '';
    let oldPrice = '';
    let savings = '';
    let items = [];
    data.isBeginner = false;
    
    if (data.goal === 'notsure' && needsCardio) {
        bundle = 'Advanced Bundle';
        price = '$59.99';
        oldPrice = '$89.97';
        savings = 'Save $29.98!';
        items = [
            { name: training, price: 29.99, bundlePrice: 19.99, image: getImageUrl(training), unavailable: false, bonuses: 5 },
            { name: nutrition, price: 29.99, bundlePrice: 19.99, image: getImageUrl(nutrition), unavailable: false, bonuses: 3 },
            { name: 'Rucking Guide', price: 29.99, bundlePrice: 19.99, image: getImageUrl('Rucking Guide'), unavailable: false, bonuses: 1 }
        ];
    } else if (data.goal === 'notsure') {
        bundle = '1 Training Plan + Full Nutrition Plan Bundle';
        price = '$69.99';
        oldPrice = '$119.96';
        savings = 'Save $49.97!';
        items = [
            { name: training, price: 29.99, bundlePrice: 17.49, image: getImageUrl(training), unavailable: false, bonuses: 5 },
            { name: 'Cutting Guide', price: 29.99, bundlePrice: 17.49, image: getImageUrl('Cutting Guide'), unavailable: false, bonuses: 3 },
            { name: 'Bulking Guide', price: 29.99, bundlePrice: 17.49, image: getImageUrl('Bulking Guide'), unavailable: false, bonuses: 3 },
            { name: 'Maintenance Plan', price: 29.99, bundlePrice: 17.49, image: getImageUrl('Maintenance Plan'), unavailable: true, bonuses: 0 }
        ];
    } else if (needsCardio) {
        bundle = 'Advanced Bundle';
        price = '$59.99';
        oldPrice = '$89.97';
        savings = 'Save $29.98!';
        items = [
            { name: training, price: 29.99, bundlePrice: 19.99, image: getImageUrl(training), unavailable: false, bonuses: 5 },
            { name: nutrition, price: 29.99, bundlePrice: 19.99, image: getImageUrl(nutrition), unavailable: false, bonuses: 3 },
            { name: 'Rucking Guide', price: 29.99, bundlePrice: 19.99, image: getImageUrl('Rucking Guide'), unavailable: false, bonuses: 1 }
        ];
    } else {
        bundle = '1+1 Bundle (Training + Nutrition)';
        price = '$49.99';
        oldPrice = '$59.98';
        savings = 'Save $9.99!';
        items = [
            { name: training, price: 29.99, bundlePrice: 24.99, image: getImageUrl(training), unavailable: false, bonuses: 5 },
            { name: nutrition, price: 29.99, bundlePrice: 24.99, image: getImageUrl(nutrition), unavailable: false, bonuses: 3 }
        ];
    }
    
    data.training = training;
    data.nutrition = nutrition;
    data.bundle = bundle;
    data.price = price;
    data.oldPrice = oldPrice;
    data.savings = savings;
    data.items = items;
    displayResults();
}

function displayResults() {
    document.getElementById('winny-quiz-finalName').textContent = data.userName || 'Friend';
    document.getElementById('winny-quiz-bundleName').textContent = data.bundle;
    document.getElementById('winny-quiz-bundlePrice').textContent = data.price;
    document.getElementById('winny-quiz-oldPrice').textContent = data.oldPrice;
    document.getElementById('winny-quiz-savings').textContent = data.savings;
    const bundleImg = document.getElementById('winny-quiz-bundleImage');
    bundleImg.style.backgroundImage = `url('${getImageUrl(data.bundle)}')`;
    
    const planNames = data.items.map(item => {
        let shortName = item.name;
        shortName = shortName.replace('Guide', '').replace('Plan', '').trim();
        return shortName;
    }).join(' + ');
    document.getElementById('winny-quiz-comboPlanNames').textContent = planNames;
    
    const comboDisplay = document.getElementById('winny-quiz-comboDisplay');
    comboDisplay.innerHTML = '';
    
    // Add special class for 4-item bundles
    if (data.items.length === 4) {
        comboDisplay.classList.add('four-items');
    } else {
        comboDisplay.classList.remove('four-items');
    }
    
    data.items.forEach(item => {
        const itemDiv = document.createElement('div');
        itemDiv.className = 'winny-quiz-combo-item';
        itemDiv.innerHTML = `
            <div class="winny-quiz-combo-side-image" style="background-image: url('${item.image}')">‎ </div>
            <div class="winny-quiz-combo-price">
                <span class="winny-quiz-combo-price-old">$${item.price.toFixed(2)}</span>
                <span class="winny-quiz-combo-price-new">$${item.bundlePrice.toFixed(2)}</span>
            </div>
        `;
        comboDisplay.appendChild(itemDiv);
    });
    buildBundleContents();
    const separator = document.getElementById('winny-quiz-separator');
    if (data.isBeginner) {
        separator.textContent = 'Sorry, these plans are only available as a bundle to ensure your success!';
    } else {
        separator.textContent = 'Not ready for the bundle? You can buy separately:';
    }
    const list = document.getElementById('winny-quiz-itemList');
    list.innerHTML = '';
    data.items.forEach(item => {
        const card = document.createElement('div');
        card.className = item.unavailable ? 'winny-quiz-item-card winny-quiz-unavailable' : 'winny-quiz-item-card';
        card.style.setProperty('--item-image', `url('${item.image}')`);
        if (item.unavailable) {
            card.innerHTML = `
                <div>
                    <span class="winny-quiz-item-name">${item.name}</span><br>
                    <span class="winny-quiz-unavailable-text">(Not available separately)</span>
                </div>
                <span class="winny-quiz-item-price">$${item.price}</span>
            `;
        } else {
            const bonusText = item.bonuses > 0 ? `<br><span style="color: #28a745; font-size: 0.9rem; font-weight: normal;">+ ${item.bonuses} FREE Bonuses</span>` : '';
            card.innerHTML = `
                <div>
                    <span class="winny-quiz-item-name">${item.name}</span>${bonusText}
                </div>
                <span class="winny-quiz-item-price">$${item.price}</span>
            `;
            card.onclick = () => buyItem(item.name, item.price);
        }
        list.appendChild(card);
    });
}

function buildBundleContents() {
    const container = document.getElementById('winny-quiz-bundleContents');
    let html = '';
    const hasTraining = data.items.some(i => 
        i.name.includes('Split') || 
        i.name.includes('Body') || 
        i.name.includes('PPL') || 
        i.name === 'Beginner Training Plan'
    );
    const hasNutrition = data.items.some(i => 
        i.name.includes('Nutrition') || 
        i.name.includes('Cutting') || 
        i.name.includes('Bulking') || 
        i.name.includes('Maintenance')
    );
    if (!data.isBeginner && (hasTraining || hasNutrition)) {
        html += '<h3>🎁 8 Extra e-books Included for FREE</h3>';
        html += '<div class="winny-quiz-carousel-container" id="winny-quiz-bonusCarousel"></div>';
    }
    container.innerHTML = html;
    if (!data.isBeginner && (hasTraining || hasNutrition)) {
        buildBonusCarousel();
    }
}

function buildBonusCarousel() {
    const bonuses = [
        {emoji: '🍞', title: 'BEST CARB SOURCES', oldPrice: '$15', image: 'https://storage.googleapis.com/msgsndr/y5JPT259OhgmfJXljudM/media/67b8ba10fa0e0b4307a9baad.png', descriptions: ['Think carbs are the enemy of your gains? Tell that to anyone who\'s ever crushed a workout without crashing halfway through.', 'The right carbs fuel your body like premium gas in a sports car. Keeping you energized, strong, and ready to dominate every rep.']},
        {emoji: '🥑', title: 'BEST HEALTHY FAT SOURCES', oldPrice: '$15', image: 'https://storage.googleapis.com/msgsndr/y5JPT259OhgmfJXljudM/media/67b8ba13fa0e0be214a9bab0.png', descriptions: ['Still scared of fats because some random guru told you they\'ll make you soft?', 'Healthy fats are the secret weapon for energy, and that lean, powerful look you\'re chasing. Don\'t skip them unless you enjoy losing.']},
        {emoji: '🍗', title: 'BEST PROTEIN SOURCES', oldPrice: '$15', image: 'https://storage.googleapis.com/msgsndr/y5JPT259OhgmfJXljudM/media/67b8ba1500fe986b6fdbec53.png', descriptions: ['You think you can build muscle without protein? Good luck sculpting a masterpiece with no clay.', 'Top-tier protein sources are the building blocks of strength and recovery. Make sure to skip this if you like hating on yourself.']},
        {emoji: '🔥', title: 'HOW TO WARM UP', oldPrice: '$15', image: 'https://storage.googleapis.com/msgsndr/y5JPT259OhgmfJXljudM/media/679df857aedcfadba2ee79b8.png', descriptions: ['This is literally one of the most underrated bonuses that have ever existed.', 'When was the last time you felt good about an injury? When was the last time you were happy, just because you couldn\'t improve yourself? Exactly.']},
        {emoji: '⚡', title: 'FAST WORKOUT GUIDE', oldPrice: '$15', image: 'https://cdn.shopify.com/s/files/1/0717/4576/5642/files/fastworkoutIMG_1.png?v=1762125020', descriptions: ['Pressed for time? Think you need 2 hours in the gym to build muscle?', 'This streamlined version cuts the fluff and keeps only what actually matters. Get in, destroy your workout, and get out.']},
        {emoji: '🏆', title: 'HOW TO ADD ABS', oldPrice: '$15', image: 'https://storage.googleapis.com/msgsndr/y5JPT259OhgmfJXljudM/media/679bb434acf507bf8cc4e4ce.png', descriptions: ['Seriously? Do I have to convince you about training your abs?', 'Both you and I know that having chiseled abs is the gateway to effortless confidence, because you never have to think twice when it\'s time to take them off.']},
        {emoji: '💪', title: 'HOW TO TRAIN FOREARMS', oldPrice: '$15', image: 'https://storage.googleapis.com/msgsndr/y5JPT259OhgmfJXljudM/media/679df857aedcfa0a55ee79b9.png', descriptions: ['Brother, you do realize that not even the emoji in the title of this section has a well-developed forearm?', 'Having exceptionally well-developed forearms will make you stand out the most and give everyone that firm handshake they deserve.']},
        {emoji: '📊', title: 'PROGRESS TRACKING GUIDE', oldPrice: '$15', image: 'https://storage.googleapis.com/msgsndr/y5JPT259OhgmfJXljudM/media/679df857e64e96979b5e0fd7.png', descriptions: ['If you are not tracking your workouts, you\'re playing darts upside down, lights off, while drunk, and you are hoping to hit a bullseye. That\'s not gonna happen.', 'You need to track how much you did last time and beat your record to grow.']}
    ];
    
    const carousel = document.getElementById('winny-quiz-bonusCarousel');
    let carouselHTML = '<div class="winny-quiz-carousel-track" id="winny-quiz-carouselTrack">';
    
    // Create items twice for seamless loop
    for (let i = 0; i < 2; i++) {
        bonuses.forEach((bonus, index) => {
            carouselHTML += `
                <div class="winny-quiz-carousel-item" onclick="openQuizBonusModal(${index})">
                    <div class="winny-quiz-carousel-item-image">
                        <img src="${bonus.image}" alt="${bonus.title}" loading="lazy">
                    </div>
                    <div class="winny-quiz-carousel-bonus-emoji">${bonus.emoji}</div>
                    <div class="winny-quiz-carousel-bonus-number">BONUS ${index + 1}</div>
                    <h4 class="winny-quiz-carousel-bonus-title">${bonus.title}</h4>
                    <div class="winny-quiz-carousel-bonus-price">
                        <span class="winny-quiz-old">${bonus.oldPrice}</span>
                        <span class="winny-quiz-free">FREE</span>
                    </div>
                </div>
            `;
        });
    }
    
    carouselHTML += '</div>';
    carouselHTML += '<div class="winny-quiz-carousel-subheadline">✋ Click to view details or drag to browse</div>';
    carousel.innerHTML = carouselHTML;
    
    // Carousel animation
    const track = document.getElementById('winny-quiz-carouselTrack');
    const itemWidth = 172; // 160px + 12px gap
    const numOriginalColumns = 8;
    const W = numOriginalColumns * itemWidth;
    let currentX = 0;
    let isDragging = false;
    let startMouseX;
    let startCurrentX;
    let animationId;
    let timeoutId;
    
    function animate() {
        if (!isDragging) {
            currentX -= 0.4;
            if (currentX <= -W) {
                currentX += W;
            }
            track.style.transform = `translateX(${currentX}px)`;
        }
        animationId = requestAnimationFrame(animate);
    }
    animate();
    
    carousel.addEventListener('mousedown', (e) => {
        isDragging = true;
        startMouseX = e.clientX;
        startCurrentX = currentX;
        cancelAnimationFrame(animationId);
    });
    
    document.addEventListener('mousemove', (e) => {
        if (isDragging) {
            const delta = e.clientX - startMouseX;
            currentX = startCurrentX + delta;
            track.style.transform = `translateX(${currentX}px)`;
        }
    });
    
    document.addEventListener('mouseup', () => {
        if (isDragging) {
            isDragging = false;
            currentX = currentX % W;
            if (currentX > 0) currentX -= W;
            track.style.transform = `translateX(${currentX}px)`;
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                animate();
            }, 3000);
        }
    });
    
    carousel.addEventListener('touchstart', (e) => {
        isDragging = true;
        startMouseX = e.touches[0].clientX;
        startCurrentX = currentX;
        cancelAnimationFrame(animationId);
    });
    
    carousel.addEventListener('touchmove', (e) => {
        if (isDragging) {
            const delta = e.touches[0].clientX - startMouseX;
            currentX = startCurrentX + delta;
            track.style.transform = `translateX(${currentX}px)`;
        }
    });
    
    carousel.addEventListener('touchend', () => {
        if (isDragging) {
            isDragging = false;
            currentX = currentX % W;
            if (currentX > 0) currentX -= W;
            track.style.transform = `translateX(${currentX}px)`;
            if (timeoutId) clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                animate();
            }, 3000);
        }
    });
    
    // Store bonus data globally for modal
    window.quizBonusData = {
        bonuses: bonuses.map(b => b.title),
        emojis: bonuses.map(b => b.emoji),
        images: bonuses.map(b => b.image),
        descriptions: bonuses.map(b => '<p>' + b.descriptions.join('</p><p>') + '</p>')
    };
}

function openQuizBonusModal(index) {
    // Create modal if it doesn't exist
    let modal = document.getElementById('winny-quiz-bonusModal');
    if (!modal) {
        modal = document.createElement('div');
        modal.id = 'winny-quiz-bonusModal';
        modal.className = 'winny-quiz-bonus-modal';
        modal.innerHTML = `
            <div class="winny-quiz-bonus-modal-content" onclick="event.stopPropagation()">
                <button class="winny-quiz-bonus-modal-close" onclick="closeQuizBonusModal()">&times;</button>
                <div class="winny-quiz-bonus-modal-image">
                    <img id="winny-quiz-modalImage" src="" alt="">
                </div>
                <div class="winny-quiz-bonus-modal-emoji" id="winny-quiz-modalEmoji"></div>
                <div class="winny-quiz-bonus-modal-number" id="winny-quiz-modalNumber"></div>
                <h2 class="winny-quiz-bonus-modal-title" id="winny-quiz-modalTitle"></h2>
                <div class="winny-quiz-bonus-modal-price">
                    <span class="old">$15</span>
                    <span class="free">FREE</span>
                </div>
                <div class="winny-quiz-bonus-modal-description" id="winny-quiz-modalDescription"></div>
            </div>
        `;
        modal.onclick = closeQuizBonusModal;
        document.body.appendChild(modal);
    }
    
    document.getElementById('winny-quiz-modalImage').src = window.quizBonusData.images[index];
    document.getElementById('winny-quiz-modalEmoji').textContent = window.quizBonusData.emojis[index];
    document.getElementById('winny-quiz-modalNumber').textContent = 'BONUS ' + (index + 1);
    document.getElementById('winny-quiz-modalTitle').textContent = window.quizBonusData.bonuses[index];
    document.getElementById('winny-quiz-modalDescription').innerHTML = window.quizBonusData.descriptions[index];
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
}

function closeQuizBonusModal(event) {
    if (!event || event.target.id === 'winny-quiz-bonusModal' || event.type === 'click') {
        const modal = document.getElementById('winny-quiz-bonusModal');
        if (modal) {
            modal.classList.remove('active');
            document.body.style.overflow = '';
        }
    }
}

function learnMore() {
    const bonusSection = document.getElementById('winny-quiz-bundleContents');
    if (bonusSection && bonusSection.innerHTML.trim() !== '') {
        bonusSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
    } else {
        const bundleUrl = productUrls[data.bundle];
        if (bundleUrl) {
            window.open(bundleUrl, '_blank');
        }
    }
}

function buyBundle() {
    let variantId = null;
    let productName = data.bundle;
    
    // Beginner Bundle - simple, only one variant
    if (data.bundle === 'Beginner Bundle' || data.bundle === 'Beginner Bodybuilding Bundle') {
        variantId = '52037010882826';
        productName = 'Beginner Bodybuilding Bundle';
    }
    
    // 1+1 Bundle (Training + Nutrition) - 8 variants
    else if (data.bundle === '1+1 Bundle (Training + Nutrition)') {
        const key = data.training + ' + ' + data.nutrition;
        variantId = oneOneVariants[key];
        productName = '1+1 Bundle (Training + Full Nutrition)';
    }
    
    // Full Nutrition Bundle (Training + All 3 Nutrition) - 4 variants
    else if (data.bundle === '1 Training Plan + Full Nutrition Plan Bundle') {
        variantId = fullNutritionVariants[data.training];
        productName = '1 Training Plan + Full Nutrition Plan Bundle';
    }
    
    // Advanced Bundle (Training + Nutrition + Rucking) - 8 variants
    else if (data.bundle === 'Advanced Bundle') {
        const key = data.training + ' + ' + data.nutrition;
        variantId = advancedVariants[key];
        productName = 'Advanced Bundle';
    }
    
    if (variantId) {
        addToCart(variantId, productName);
    } else {
        console.error('Variant not found for:', {
            bundle: data.bundle,
            training: data.training,
            nutrition: data.nutrition,
            lookupKey: data.training + ' + ' + data.nutrition
        });
        alert('Sorry, there was an error finding this bundle variant. Please contact support.');
    }
}

function buyItem(name, price) {
    const variantId = variantIds[name];
    if (variantId) {
        addToCart(variantId, name);
    } else {
        alert('Product variant not found. Item: ' + name);
    }
}

function addToCart(variantId, productName) {
    const buyBtn = event?.target;
    const originalText = buyBtn?.textContent || 'I want this!';
    if (buyBtn) {
        buyBtn.disabled = true;
        buyBtn.textContent = 'Adding...';
    }
    
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            id: variantId,
            quantity: 1
        })
    })
    .then(response => {
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
        return response.json();
    })
    .then(addedItem => {
        console.log('Successfully added to cart:', addedItem);
        
        // Get the product URL and redirect with cart_open parameter
        const productUrl = productUrls[productName];
        if (productUrl) {
            window.location.href = productUrl + '?cart_open=true';
        } else {
            // Fallback: just reload current page with cart_open
            window.location.href = window.location.origin + window.location.pathname + '?cart_open=true';
        }
    })
    .catch(error => {
        console.error('Error adding to cart:', error);
        alert('Sorry, there was an error adding this to your cart. Please try again.');
        if (buyBtn) {
            buyBtn.disabled = false;
            buyBtn.textContent = originalText;
        }
    });
}

function restartQuiz() {
    step = 1;
    data = {};
    document.querySelectorAll('input[type="radio"]').forEach(i => {
        i.checked = false;
        i.closest('.winny-quiz-radio-option').classList.remove('winny-quiz-selected');
    });
    document.querySelectorAll('input[type="text"], input[type="email"], input[type="number"]').forEach(i => {
        i.value = '';
    });
    document.getElementById('winny-quiz-gymDays').value = 4;
    document.getElementById('winny-quiz-gymDaysValue').textContent = 4;
    document.getElementById('winny-quiz-sessionTime').value = 45;
    document.getElementById('winny-quiz-sessionTimeValue').textContent = 45;
    document.getElementById('winny-quiz-confusion').value = 5;
    document.getElementById('winny-quiz-confusionValue').textContent = 5;
    const resultsWrapper = document.getElementById('winny-quiz-resultsWrapper');
    const quizWrapper = document.getElementById('winny-quiz-quizWrapper');
    resultsWrapper.classList.remove('winny-quiz-active', 'winny-quiz-fade-in');
    quizWrapper.classList.remove('winny-quiz-fade-out');
    quizWrapper.style.display = 'flex';
    showStep(1);
    updateProgress();
    document.getElementById('winny-quiz-successCount').textContent = 200 + Math.floor(Math.random() * 100);
}